<template>
  <thead>
    <tr class="text-muted">
      <th v-if="number">No</th>
      <th v-for="(row, i) in data" :key="i">{{ row.replace("_", " ") }}</th>
      <slot></slot>
      <th v-if="action"></th>
    </tr>
  </thead>
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    data: { default: [] },
    number: { default: true },
    action: { default: false },
  },
};
</script>